import React from 'react';
import HighlightText from './HighlightText';
import Know_your_progress from "../../../assets/Images/Know_your_progress.png"
import Compare_with_others from "../../../assets/Images/Compare_with_others.svg"
import Plan_your_lessons from "../../../assets/Images/Plan_your_lessons.svg"
import CTAButton from "../HomePage/Button";


function LearningLanguageSection(props) {
    return (
        <div className='mt-16 mb-14'>
            <div className='flex flex-col gap-5 items-center'>
                <div className='text-4xl font-semibold text-center'>
                    Your Swiss Knife for <HighlightText text={"learning any language"}/>
                </div>
                <div className='text-center w-[70%] text-richblack-600 mx-auto text-base font-medium '>
                    <p>Using spin making learning multiple languages easy. with 20+ languages realistic voice-over, progress tracking, custom schedule and more.</p>
                </div>
                <div className='flex lg:flex-row flex-col items-center justify-center mt-5'>
                    <img className='object-contain md:-mr-32' src={Know_your_progress} alt="knowYourProgress" />
                    <img className='object-contain md:mt-12' src={Compare_with_others} alt="knowYourProgress" />
                    <img className='object-contain md:-ml-32' src={Plan_your_lessons} alt="knowYourProgress" />
                </div>
                <div className='w-fit'>
                    <CTAButton active={true} linkto={"/signup"}>Learn More</CTAButton>
                </div>
            </div>
        </div>
    );
}

export default LearningLanguageSection;